import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import SharedReactTable from "components/shared/reactTable";
import { feedbackTagFlags } from "helpers/enums";
import { isDeletedColumn, rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import FeedbackTagsForm from "./form";

class FeedbackTags extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({ value, row: { original } }) => (
                    <div
                        className="link"
                        onClick={() =>
                            this.props.modal({
                                title: "Изменение тега",
                                name: "default",
                                windowMod: "sm",
                                CustomBody: (props) => (
                                    <FeedbackTagsForm {...props} data={original} mergeParams={this.props.mergeParams} />
                                ),
                            })
                        }
                    >
                        {value}
                    </div>
                ),
            },
            {
                Header: "Флаги",
                accessor: "flags",
                sortable: false,
                filterable: false,
                Cell: ({ value }) => (
                    <div>
                        {value
                            .split(", ")
                            .map((flag) => enumLabel(feedbackTagFlags, flag))
                            .join(", ")}
                    </div>
                ),
                CSVExport: ({ value }) =>
                    value
                        .split(", ")
                        .map((flag) => enumLabel(feedbackTagFlags, flag))
                        .join(", "),
            },
            isDeletedColumn(this.restore, true),
        ];
    }

    renderCreateButton = () => {
        const { modal, mergeParams } = this.props;

        const props = {
            className: "btn btn-brand btn-sm",
            onClick: () =>
                modal({
                    title: "Добавление тега",
                    name: "default",
                    windowMod: "sm",
                    CustomBody: (props) => <FeedbackTagsForm {...props} mergeParams={mergeParams} />,
                }),
        };
        return <div {...props}>Добавить тег</div>;
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;

    render() {
        return (
            <div className="page-content">
                <Transition dir="full">
                    <div className="page-book__list book-list list">
                        {this.renderHead()}
                        <div className="container-fluid my-2">{this.renderActions()}</div>
                        {this.renderListComponent()}
                    </div>
                </Transition>
            </div>
        );
    }
}

export default tableContainer(FeedbackTags, "feedback-tags");
